module.exports = __webpack_public_path__ + "static/media/p0304.1a9df7c5.png";